import type { User } from '../types/user';

const COOKIE_TOKEN = 'auth_token';
const COOKIE_USER = 'auth_user';
const MAX_AGE_DAYS = 2;

function setCookie(name: string, value: string, maxAgeDays: number = MAX_AGE_DAYS): void {
  const maxAge = maxAgeDays * 24 * 60 * 60;
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; SameSite=Lax`;
}

function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  return match ? decodeURIComponent(match[2]) : null;
}

function removeCookie(name: string): void {
  document.cookie = `${name}=; path=/; max-age=0`;
}

export function setAuthToken(token: string): void {
  setCookie(COOKIE_TOKEN, token);
}

export function getAuthToken(): string | null {
  return getCookie(COOKIE_TOKEN);
}

export function removeAuthToken(): void {
  removeCookie(COOKIE_TOKEN);
}

export function setAuthUser(user: User): void {
  setCookie(COOKIE_USER, JSON.stringify(user));
}

export function getAuthUser(): User | null {
  const raw = getCookie(COOKIE_USER);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as User;
  } catch {
    return null;
  }
}

export function removeAuthUser(): void {
  removeCookie(COOKIE_USER);
}

export function clearAuthCookies(): void {
  removeAuthToken();
  removeAuthUser();
}
